module.exports = __webpack_public_path__ + "img/primary_3x3.fe1a7671.svg";